module.exports = {"tollFree":"Toll-free orders available at","tollFreeNumber":"1-866-967-8167","tollFreeNumberTel":"tel:18669678167","saveDraft":"Save draft","savePublish":"Save and publish","update":"Update","saveCoupon":"Save Coupon","createCoupon":"Create Coupon","saveFlexpass":"Save Flex Pass","createFlexpass":"Create Flex Pass","contactUs":"Contact us"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/locales/en.json
// module id = 787
// module chunks = 0